import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Amplify from 'aws-amplify';
import { SnackbarProvider } from 'notistack';

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: "MyAPIGatewayAPI",
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        region: process.env.REACT_APP_REGION,
      }
    ]
  },
  Storage: {
     bucket: process.env.REACT_APP_BUKET_NAME,
     region: process.env.REACT_APP_REGION,
     identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
  }
});

ReactDOM.render(
  <SnackbarProvider
    maxSnack={10}
    anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
    }}
  >
    <App />
  </SnackbarProvider>,
  document.getElementById('root')
);

registerServiceWorker();
